import reducers from './reducers';

export {
    actions as productsOperations,
    default as productsSaga,
} from './operations';

export default reducers;
